<template>
  <div>
    <!-- <v-row col="10">
      <v-col align="center" justify="center">
        <v-img
          :src="require('@/assets/logoIcon.png')"
          class="responsive"
        ></v-img>
      </v-col>
    </v-row> -->

    <v-toolbar color="primary">
      <v-card-title> Transaction Report </v-card-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-card-actions>
          <downloadexcel
            :data="reportData"
            :fields="json_fields"
            worksheet="Siam_Premium_Outlet"
            name="Siam_Premium_Outlet_Report.xls"
          >
            <v-btn text color="white"
              ><v-icon class="px-2" color="white" size="medium"
                >fas fa-download</v-icon
              >Report</v-btn
            >
          </downloadexcel>
        </v-card-actions>
        <v-btn text color="white" @click="logout"
          ><v-icon class="px-2" color="white" size="medium"
            >fas fa-sign-out-alt</v-icon
          >Logout</v-btn
        >
      </v-toolbar-items>
    </v-toolbar>

    <v-card-text>
      <v-col cols="4">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label=" ค้นหา (ชื่อ-นามสกุล, เบอร์มือถือ)"
          single-line
          servedetails
          hide-yarn
        >
        </v-text-field>
      </v-col>
    </v-card-text>

    <v-data-table :headers="headers" :items="reportData" :search="search">
      <template v-slot:item.createdAt="{ item }">
        {{ item.createdAt | convertTimeStampCreatedDate }}
      </template>
      <template v-slot:item.policy_other="{ item }">
        <v-icon right secondary color="blue lighten-2" v-if="item.policy_other"
          >mdi-checkbox-marked-circle
        </v-icon>
        <v-icon right v-else color="red lighten-2"> mdi-cancel </v-icon>
      </template>
      <template v-slot:item.policy_email="{ item }">
        <v-icon right secondary color="blue lighten-2" v-if="item.policy_email"
          >mdi-checkbox-marked-circle
        </v-icon>
        <v-icon right v-else color="red lighten-2"> mdi-cancel </v-icon>
      </template>
      <template v-slot:item.policy_sms="{ item }">
        <v-icon right secondary color="blue lighten-2" v-if="item.policy_sms"
          >mdi-checkbox-marked-circle
        </v-icon>
        <v-icon right v-else color="red lighten-2"> mdi-cancel </v-icon>
      </template>
      <template v-slot:item.policy_terms="{ item }">
        <v-icon right secondary color="blue lighten-2" v-if="item.policy_terms"
          >mdi-checkbox-marked-circle
        </v-icon>
        <v-icon right v-else color="red lighten-2"> mdi-cancel </v-icon>
      </template>
      <template v-slot:item.policy_voice="{ item }">
        <v-icon right secondary color="blue lighten-2" v-if="item.policy_voice"
          >mdi-checkbox-marked-circle
        </v-icon>
        <v-icon right v-else color="red lighten-2"> mdi-cancel </v-icon>
      </template>
    </v-data-table>
  </div>
</template>


<script>
import router from "../router";
import { authFirebase } from "../../firebase_instant";
import downloadexcel from "vue-json-excel";
export default {
  components: {
    downloadexcel,
  },
  beforeCreate() {
    authFirebase.auth().onAuthStateChanged((user) => {
      if (!user) {
        router.push("/login");
      }
    });
  },
  created() {
    this.fetchData();
  },

  data() {
    return {
      report: null,
      search: "",
      headers: [
        {
          text: "ชื่อ - นามสกุล",
          align: "start",
          value: "name",
          sortable: false,
          width: "150px",
        },
        {
          text: "เบอร์มือถือ",
          value: "mobile",
          sortable: false,
        },
        { text: "อีเมล", value: "email", sortable: false },
        { text: "วันเกิด", value: "birthDay", width: "130px", sortable: false },
        {
          text: "เพศ",
          value: "gender",
          sortable: false,
        },
        {
          text: "จังหวัด",
          value: "province",
          sortable: false,
        },
        {
          text: "สินค้าที่ชื่นชอบ",
          value: "categories",
          sortable: false,
          width: "130px",
        },
        {
          text: "บันทึกวันที่",
          align: "start",
          value: "createdAt",
          width: "200px",
        },
        { text: "policy_email", value: "policy_email", sortable: false },
        { text: "policy_other", value: "policy_other", sortable: false },
        { text: "policy_sms", value: "policy_sms", sortable: false },
        { text: "policy_terms", value: "policy_terms", sortable: false },
        { text: "policy_voice", value: "policy_voice", sortable: false },
      ],
    };
  },
  methods: {
    logout() {
      authFirebase
        .auth()
        .signOut()
        .then(() => {
          router.push("/");
        });
    },
    fetchData() {
      this.$store.dispatch("fetchDataFromSql");
    },
  },
  computed: {
    reportData() {
      return this.$store.getters["reportData"];
    },

    json_fields() {
      const dataPerson = {
        ชื่อ: "name",
        เบอร์โทรศัพท์: {
          field: "mobile",
          callback: (value) => {
            return `${value}&nbsp;`;
          },
        },
        วันเกิด: "birthDay",
        อีเมล: "email",
        เพศ: "gender",
        จังหวัด: "province",
        สินค้าที่ชอบ: "categories",
        วันลงทะเบียน: {
          field: "createdAt",
          callback: (value) => {
            return new Date(value).toLocaleTimeString("th-TH", {
              year: "numeric",
              month: "long",
              day: "numeric",
            });
          },
        },
        policy_email: "policy_email",
        policy_other: "policy_other",
        policy_sms: "policy_sms",
        policy_terms: "policy_terms",
        policy_voice: "policy_voice",
      };
      return dataPerson;
    },
  },
  filters: {
    convertTimeStampCreatedDate(item) {
      return new Date(item).toLocaleTimeString("th-TH", {
        year: "numeric",
        month: "long",
        day: "numeric",
      });
    },
  },
};
</script>

<style >
.v-card-title {
  font-family: "Mitr" !important;
}
.theme--light.v-sheet {
  color: aliceblue;
}
</style>